module.exports = {
          srcSet: __webpack_public_path__ + "public/bdba97a0243a229617f8dfe7ccc0949b-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/bdba97a0243a229617f8dfe7ccc0949b-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/bdba97a0243a229617f8dfe7ccc0949b-80.png",
          toString:function(){return __webpack_public_path__ + "public/bdba97a0243a229617f8dfe7ccc0949b-80.png"},
          
          width: 80,
          height: 80
        }